module.exports = __webpack_public_path__ + "img/a5vl2-r5eym.64e1855c.png";